import {createActionTypes} from './createActionTypes';
import {createActions} from './createActions';
import {createReducers} from './createReducers';
import createSagas from './createSagas';


export default function createStore(entity) {
    const actionTypes = createActionTypes(entity);
    const actions = createActions(actionTypes);
    const reducers = createReducers(actionTypes);
    const sagas = createSagas(actions, actionTypes, entity);

    return {actionTypes, actions, reducers, sagas}
}